import { Notification } from '../../models/notification';

export interface NotificationsState {
  notifications: Notification[]
}

export const initialNotificationsState: NotificationsState = {
  notifications: []
};
